// extracted by mini-css-extract-plugin
export default {"contactItem":"ContactItem_contactItem__akpex"};